import GroupCards from './groups';

export default GroupCards;
